import React from 'react';
const IconStatusPaused = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 19H10V5H6V19Z" fill="#666666"/>
<path d="M14 5V19H18V5H14Z" fill="#666666"/>
</svg>
);
};
export default IconStatusPaused;